import React, { useState } from 'react'
import Swiper from 'react-id-swiper'

import MobilityCard from '../MobilityCard'
import { mobilityInfo } from '../MobilityCard/info'
import phone1 from './phone-1.svg'
import phone2 from './phone-2.svg'
import phone3 from './phone-3.svg'
import * as S from './styled'

const MobilitySlide = () => {
  const [active, setActive] = useState(0)
  const [swiper, setSwiper] = useState(null)

  const settings = {
    slidesPerView: 1,
    effect: 'fade'
  }

  const goToSlide = (index) => {
    if (swiper !== null) {
      swiper.slideTo(index)
      setActive(index)
    }
  }

  return (
    <S.MobilityWrapper>
      <S.MobilitySlide>
        <Swiper {...settings} getSwiper={setSwiper}>
          <S.MobilitySlideItem image={phone1} />
          <S.MobilitySlideItem image={phone2} />
          <S.MobilitySlideItem image={phone3} />
        </Swiper>
      </S.MobilitySlide>

      <S.MobilityCardsGroup>
        {mobilityInfo.map(({ title, description }, key) => (
          <S.MobilityCardItem
            key={key}
            onClick={() => goToSlide(key)}
            onMouseEnter={() => goToSlide(key)}
          >
            <MobilityCard
              title={title}
              description={description}
              className={swiper !== null && active === key ? 'active' : ''}
            />
          </S.MobilityCardItem>
        ))}
      </S.MobilityCardsGroup>
    </S.MobilityWrapper>
  )
}

export default MobilitySlide
